<template>
  <div class="sb_wrapper">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Wrapper',
};
</script>

<style lang="scss">
#sb_fotowand-designer {
  .sb_wrapper {
    padding: 0 1rem;
  }
}
</style>
